import { render, staticRenderFns } from "./TransferCallReport.vue?vue&type=template&id=a71671ba"
import script from "./TransferCallReport.vue?vue&type=script&lang=js"
export * from "./TransferCallReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports